<template>
  <article class="intro-wrapper">
    <VueSlickCarousel v-bind="settings">
      <div class="slide">
        <div class="img00"></div>
      </div>
      <div class="slide">
        <div class="img01"></div>
      </div>
      <div class="slide">
        <div class="img02"></div>
      </div>
      <div class="slide">
        <div class="img03"></div>
      </div>
    </VueSlickCarousel>
    <p class="title">
      서로에게서<br />최고의 것을 발견하고,<br />최고의 것을 주는 사람들,<br />우리는
      CARROT입니다.
    </p>
  </article>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 3000,
        cssEase: "linear",
        fade: true,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.intro-wrapper {
  position: relative;
  height: 100vh;

  .slide {
    display: block !important;
    height: 100vh;

    .img00 {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/newGlobal/introduce/main/intro/bg_top_01.png)
        no-repeat center/ cover;
    }

    .img01 {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/newGlobal/introduce/main/intro/bg_top_02.png)
        no-repeat center/ cover;
    }

    .img02 {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/newGlobal/introduce/main/intro/bg_top_03.png)
        no-repeat center/ cover;
    }

    .img03 {
      width: 100%;
      height: 100%;
      background: url(~@/assets/img/newGlobal/introduce/main/intro/bg_top_04.png)
        no-repeat center/ cover;
    }

    img {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
    }
  }

  .title {
    width: calc(100% - 40px);
    max-width: 1200px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 25px;
    font-weight: 700;
    color: #ffffff;

    @media screen and (min-width: 1350px) {
      font-size: 50px;
    }
  }
}
</style>
